var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gz-public__page gz-public__authorization-page",attrs:{"slot":"content"},slot:"content"},[_c('GZ-Authorization')],1)}
var staticRenderFns = []

export { render, staticRenderFns }